import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  close = () => {
    const frame = this.element.closest("turbo-frame") as HTMLElement | null;
    if (frame) frame.innerHTML = "";
  };

  onKeydown = (e: KeyboardEvent) => {
    if (e.key === "Escape") this.close();
  };
}
